module.exports = __webpack_public_path__ + "assets/22927d7ac8d5e593863eb8cb5654ab76.mp4";